export default {
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  locationTree: state => state.locationTree,
  locations: state => state.locations,
  location: state => state.location,
  locationsFound: state => state.locationsFound,
  preferences: state => state.preferences,
  currentLocation: state => state.currentLocation,
  emailTemplate: state => state.emailTemplate,
  dispatchedTechs: state => state.dispatchedTechs
}



// WEBPACK FOOTER //
// ./src/store/modules/locations/getters.js